exports = module.exports = require("../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-chatpanel-item.m-chatpanel-agent .chat .body {\n  border-radius: 5px;\n  background: #efefef;\n  box-shadow: none; }\n\n.m-chatpanel-item.m-chatpanel-agent .alime-agent._block {\n  min-height: 37px; }\n\n.m-chatpanel-item.m-chatpanel-agent + .m-chatpanel-item.m-chatpanel-agent {\n  padding-top: 4px; }\n  .m-chatpanel-item.m-chatpanel-agent + .m-chatpanel-item.m-chatpanel-agent .alime-agent._block:before {\n    display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader??ref--3-1!./node_modules/_sass-loader@4.0.2@sass-loader??ref--3-2!./node_modules/_postcss-loader@1.3.3@postcss-loader??ref--3-3!./src/app/extension/agent/style.scss
// module id = 382
// module chunks = 0 1